import { quoteNumber } from './quoteDisplay'

// Request failures resolve to 0; only a complete preview may unlock confirmation.
export function isContractPreview(info) {
  return !!info && typeof info === 'object' && !Array.isArray(info) &&
    ['money', 'deposit', 'funding', 'multiple', 'days', 'position_limit', 'point'].every(key => quoteNumber(info[key]) != null)
}
